import { useQuery } from '@tanstack/react-query';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import { OpenPosition } from '@velocity-exchange/common';
import { useWarnIfProviderMissing } from './useWarnIfProviderMissing';
import {
	accountTradingDataQueryKeys,
	GC_TIME_MS,
} from './accountTradingDataQueryKeys';
import { PositionsResult, PositionsByUserKey } from './utils/types';

const EMPTY_POSITIONS: OpenPosition[] = [];

export function usePositionsByUserKey(userKey: string | undefined) {
	useWarnIfProviderMissing('usePositionsByUserKey');

	return useQuery<PositionsByUserKey, unknown, PositionsResult | undefined>({
		queryKey: accountTradingDataQueryKeys.positions(),
		queryFn: () => ({}),
		enabled: false,
		staleTime: Infinity,
		gcTime: GC_TIME_MS,
		select: (data) => (userKey ? data?.[userKey] : undefined),
	});
}

export function useCurrentAccountPositions(): OpenPosition[] {
	const userKey = useDriftAccountStore((s) => s.currentUserKey);
	const { data: result } = usePositionsByUserKey(userKey);
	return result?.openPerpPositions ?? EMPTY_POSITIONS;
}

export function useAllAccountsPositions() {
	useWarnIfProviderMissing('useAllAccountsPositions');

	return useQuery<PositionsByUserKey>({
		queryKey: accountTradingDataQueryKeys.positions(),
		queryFn: () => ({}),
		enabled: false,
		staleTime: Infinity,
		gcTime: GC_TIME_MS,
	});
}
